import React, { useEffect, useState } from 'react';
import HomeAccommodation from './HomeAccommodation';
import HomeActivities from './HomeActivities';
import HomeBundles from './HomeBundles';
import HomeMapSection from './HomeMapSection';
import HomeMenuSection from './HomeMenuSection';
import HomeContactFooter from './HomeContactFooter';
import HomeAppleHero from './HomeAppleHero';
import { resolveExperienceMode } from '../core/resolveExperienceMode';
import './home-product-rail.css';

const HomePage: React.FC = () => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window === 'undefined' ? false : resolveExperienceMode(window.innerWidth) === 'mobile'
  );

  useEffect(() => {
    const sync = () => {
      setIsMobile(resolveExperienceMode(window.innerWidth) === 'mobile');
      // Legacy class from older vertical snap — ensure it cannot fight natural scroll.
      document.documentElement.classList.remove('home-product-snap');
    };

    sync();
    window.addEventListener('resize', sync);
    return () => {
      window.removeEventListener('resize', sync);
      document.documentElement.classList.remove('home-product-snap');
    };
  }, []);

  return (
    <>
      {/* Desktop / pad: photo carousel stays at the top */}
      {!isMobile ? <HomeAppleHero placement="hero" /> : null}

      {/* Mobile: clear sticky brand + nav (carousel no longer provides this offset). */}
      {isMobile ? (
        <div
          aria-hidden
          className="w-full shrink-0"
          style={{ height: 'var(--wd-header-clearance)' }}
        />
      ) : null}

      {/*
        Natural vertical scroll between product types (no document snap — avoids mobile settle glitches).
        Mobile order: stays → activities → carousel → bundles…
      */}
      <div className="home-product-types">
        <HomeAccommodation />
        <HomeActivities />
        {isMobile ? <HomeAppleHero placement="section" /> : null}
        <HomeBundles />
      </div>
      <HomeMapSection />
      <HomeMenuSection />
      <HomeContactFooter />
    </>
  );
};

export default HomePage;
